module.exports = "<div class=\"container-fluid background-dark\"> <div class=\"row standard-margin-bottom\"> <div class=\"col-lg-6 col-lg-offset-1\"> <ink-project project=$ctrl.project current-appointment=$ctrl.currentAppointment on-project-change=$ctrl.updateProject(project) open=$ctrl.open> </ink-project> </div> <div class=col-lg-4> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./routes/project/project-route.template.html
// module id = ./routes/project/project-route.template.html
// module chunks = 0